import type { ReactNode } from 'react';
import { SEO } from '../../shared/components/SEO';
import type { FAQItem } from '../../shared/data/faqs';

type PageShellProps = {
  title: string;
  description: string;
  path: string;
  eyebrow?: string;
  children: ReactNode;
  breadcrumbs?: { label: string; href?: string }[];
  faqs?: FAQItem[];
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  hideHeader?: boolean;
  preloadImages?: { href: string; fetchPriority?: 'high' | 'low' | 'auto'; as?: 'image' }[];
};

export function PageShell({ title, description, path, eyebrow, children, breadcrumbs, faqs, jsonLd, hideHeader, preloadImages }: PageShellProps) {
  return (
    <>
      <SEO title={`${title} | Zfast Agritech India`} description={description} path={path} breadcrumbs={breadcrumbs} faqs={faqs} jsonLd={jsonLd} preloadImages={preloadImages} />
      {!hideHeader && (
        <section className="bg-[radial-gradient(circle_at_top_left,rgba(238,245,182,.65),transparent_24rem),linear-gradient(180deg,#F4FBF0,#fff)]">
          <div className="mx-auto w-full max-w-[1540px] px-4 py-12 sm:px-6 sm:py-16 lg:px-10 lg:py-20">
            {eyebrow && <p className="text-xs font-black uppercase tracking-[0.18em] text-gold sm:text-sm sm:tracking-[0.24em]">{eyebrow}</p>}
            <h1 className="mt-3 max-w-5xl text-4xl font-black leading-tight tracking-[-0.04em] text-ink sm:text-5xl lg:text-7xl">{title}</h1>
            <p className="mt-5 max-w-4xl text-base leading-7 text-charcoal/75 sm:text-lg sm:leading-8">{description}</p>
          </div>
        </section>
      )}
      {children}
    </>
  );
}
